import type { IVendor } from "../../../../types/models/vendor.modals.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
    vendors: IVendor[];
}

export function useGetAllVendorsHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/vendors",
  });
}
